/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { setSelected } from "./warehouseSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  StatusFormatter,
  attachFormatter,
} from "../../utility";
export const WarehouseTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const showDetail = (column) => {
    dispatch(setSelected(column));
    history.push("/chief-warehouse/warehouse-detail");
    // return new Promise((resolve,reject)=>{
    //   resolve(dispatch(setSelected(column)))
    // })
    // .then(()=>{

    // })
  };

  const dateFormatter = (cell) => {
    if (cell === "0001-01-01T00:00:00Z") {
      return <span> </span>;
    } else {
      return <span>{formatDate(cell)}</span>;
    }
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, column, formatExtraData) => {
        return (
          <div>
            <OverlayTrigger
              overlay={
                <Tooltip id="products-edit-tooltip">Confirm FPRE</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={() => showDetail(column)}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Files/File-done.svg")}
                  />
                </span>
              </a>
            </OverlayTrigger>
          </div>
        );
      },
    },
    {
      text: "Upload FPRE Date",
      dataField: "fpreUploadTime",
      sort: true,
      sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Created By",
      dataField: "userName",
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret,
      headerSortingClasses,
    },
    {
      text: "Remarks Return",
      dataField: "remark",
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const detailColumns = [
    { text: "Material", dataField: "materialCode" },
    {
      text: "Material Desc",
      dataField: "materialName",
    },
    { text: "Rayon Type", dataField: "rayonType" },
    { text: "Batch", dataField: "batch" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Return Uom",
      dataField: "returnUom",
    },
    {
      text: "Nra",
      dataField: "nra",
      formatter: StatusFormatter,
    },
    { text: "Qty", dataField: "qty", align: "center" },
    { text: "ClientCode", dataField: "clientCode", align: "center" },
    { text: "Exp Date", dataField: "expiredDate", formatter: dateFormatter },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      formatter: attachFormatter,
      align: "center",
    },
    { text: "FSS/ASM/BM", dataField: "salesmanName" },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const expandRow = {
    expandByColumnOnly: true,
    showExpandColumn: true,
    renderer: (row) => (
      <BootstrapTable
        keyField="materialCode"
        data={row.items}
        columns={detailColumns}
      />
    ),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="retNumber"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        expandRow={expandRow}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
    </>
  );
};
